import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Configuration, PursesService } from '../../api-client';
import { Purse } from '../../models/purse';
import { map, Observable, tap } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PurseService extends PursesService {
  purses: Purse[] = [];

  constructor(httpClient: HttpClient, config: Configuration) {
    super(httpClient, config.basePath!, config);
    this.getAll().subscribe();
  }

  getAll(): Observable<Purse[]> {
    return super.getPurseBreakdownsEndpoint().pipe(
      map((purses: Purse[]) =>
        purses.map((purse, index) => ({
          ...purse,
          id: index,
        }))
      ),
      tap((purses: Purse[]) => {
        this.purses = purses;
      })
    );
  }
}
